import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import _ from 'lodash'

import config from '../../../config'
import ImageSize from './ImageSize'

const createImageURL = imageID => config.imageURLPrefix + '/' + imageID

//originalImageID change when image replaced
const ImagePreview = ({
  lastChecked,
  imageID,
  onImageSelect,
  onImageRemove,
  isRemoveBtn = true,
  isSelect = false,
  ...props
}) => {
  const imageRef = React.useRef()
  return (
    <MediaLayout
      isSelect={isSelect}
      isRemoveBtn={isRemoveBtn}
      onDelete={e => {
        e.stopPropagation()
        if (onImageRemove) onImageRemove(imageID)
      }}
    >
      <Image
        innerRef={imageRef}
        src={createImageURL(imageID + '?' + lastChecked)}
        onClick={() => onImageSelect && onImageSelect(imageID)}
        alt=""
        {...props}
      />
      <ImageSize imageRef={imageRef} />
    </MediaLayout>
  )
}

ImagePreview.propTypes = {
  imageID: PropTypes.string.isRequired,
  lastChecked: PropTypes.string,
  onImageSelect: PropTypes.func,
  onImageRemove: PropTypes.func,
  isSelect: PropTypes.bool,
}

export default ImagePreview

const MediaLayout = ({
  children,
  onDelete,
  onSelect,
  isSelect,
  isRemoveBtn,
}) => (
  <ImageCard>
    {children}
    {isRemoveBtn && (
      <DeleteLayout>
        <button className="delete" onClick={onDelete} />
      </DeleteLayout>
    )}

    {isSelect && (
      <SelectLayout onClick={onSelect}>
        <span className="icon has-text-success">
          <i className="fas fa-3x fa-check-square" />
        </span>
      </SelectLayout>
    )}
  </ImageCard>
)

const ImageCard = styled.div`
  background-color: #f1f1f1;
  height: 125px;
  min-width: 125px;
  // margin: 10px;
  text-align: center;
  line-height: 75px;
  position: relative;
  box-shadow: 0 8px 16px rgba(10, 10, 10, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
`
ImageCard.displayName = 'ImageCard'

const Image = styled.img`
  max-width: 100% !important;
  max-height: 125px;
  //min-height: 125px;
`
Image.displayName = 'Image'

const DeleteLayout = styled.div`
  position: absolute;
  top: 3px;
  right: 3px;
`
DeleteLayout.displayName = 'DeleteLayout'

const SelectLayout = styled.div`
  position: absolute;
  bottom: 10px;
  left: 18px;
  line-height: 0px !important;
`

SelectLayout.displayName = 'SelectLayout'



// WEBPACK FOOTER //
// ./src/components/templates/image-preview/ImagePreview.js